export enum EField {
  Address = "address",
  FirstName = "firstname",
  LastName = "lastname",
  Email = "email",
  MobileNumber = "phone",
  Language = "locale",
  CountryId = "countryId",
}
